import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// style
import { styles, LegendTableCell } from './style';
import './styles.css';

// images
import ImgEWS from '../../../assets/banner/ews.png';

function createData(color, comment) {
  return { color, comment };
}

const useStyles = makeStyles(styles);

export default function MapLegend(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { legend } = props;

  const rowsRainfall24 = [
    createData('#FE8A04', <Box pl={1}>{t('เฝ้าระวังพิเศษ')}</Box>),
    createData('#EE141F', <Box pl={1}>{t('วิกฤต')}</Box>),
  ];

  const rowsWaterLevel = [
    createData('#DB802B', <Box pl={1}>{t('น้ำน้อยวิกฤติ')}</Box>),
    createData('#FF0000', <Box pl={1}>{t('น้ำล้นตลิ่ง')}</Box>),
  ];

  const rowsDam = [
    createData('#FFC000', <Box pl={1}>{t('เขื่อนน้ำน้อยวิกฤต (% น้ำใช้การ)')}</Box>),
    createData('#FF0000', <Box pl={1}>{t('เขื่อนน้ำมากวิกฤต (% ระดับน้ำกักเก็บ)')}</Box>),
  ];

  const rowsForecastRainfall = [
    createData('#F0AD4E', <Box pl={1}>{t('ฝนตกหนัก')}</Box>),
    createData('#FF0000', <Box pl={1}>{t('ฝนตกหนักมาก')}</Box>),
  ];
  const rowsForecastWave = [
    createData('#FF0000', <Box pl={1}>{t('คลื่นสูงมากกว่า 2 เมตร')}</Box>),
  ];

  const rowsRisk = [
    createData('#FF0000', <Box pl={1}>{t('เตือนภัยสีแดง')}</Box>),
    createData('#FFFF00', <Box pl={1}>{t('เตือนภัยสีเหลือง')}</Box>),
  ];

  function MapRainfallLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsRainfall24.map((row) => (
                <TableRow key={row.colori}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
            <Box>
              *
              {' '}
              {t('นับเฉพาะขั้นวิกฤติ')}
            </Box>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapWaterLevelLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsWaterLevel.map((row) => (
                <TableRow key={row.color}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapDamLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsDam.map((row) => (
                <TableRow key={row.color}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapQualityLegend() {
    return (
      <>
        <TableContainer style={{ marginTop: 10 }}>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center" colSpan={3}>
                  {t('ความเค็ม')}
                  {' '}
                  (g/L)
                </LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="center" width="200px">ค่า</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell style={{ background: '#B02318' }} />
                <LegendTableCell align="center">{t('มากกว่า 2 กรัม ต่อลิตร')}</LegendTableCell>
                <LegendTableCell align="left">{t('เกินมาตรฐานคุณภาพเพื่อการผลิตน้ำประปา')}</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{t('มากกว่า 0.50 กรัม ต่อลิตร')}</LegendTableCell>
                <LegendTableCell align="left">{t('เกินมาตรฐานคุณภาพเพื่อการเกษตร')}</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FFA500' }} />
                <LegendTableCell align="center">{t('มากกว่า 0.25 กรัม ต่อลิตร')}</LegendTableCell>
                <LegendTableCell align="left">{t('เฝ้าระวังคุณภาพน้ำดินเพื่อผลิตน้ำประปา')}</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TableContainer style={{ marginTop: 10 }}>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center" colSpan={3}>ออกซิเจน (mg/L)</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="center" width="200px">ค่า</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">น้อยกว่า 3 กรัม ต่อลิตร</LegendTableCell>
                <LegendTableCell align="left">สูงกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 10 }}>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center" colSpan={3}>กรด-ด่าง (pH)</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="center" width="200px">ค่า</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell style={{ background: '#66C803' }} />
                <LegendTableCell align="center">6.5 - 9</LegendTableCell>
                <LegendTableCell align="left">มาตรฐาน</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{'> 9'}</LegendTableCell>
                <LegendTableCell align="left">สูงกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{'< 6.5'}</LegendTableCell>
                <LegendTableCell align="left">ต่ำกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 10 }}>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center" colSpan={3}>ความขุ่น (ntu)</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="center" width="200px">ค่า</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell style={{ background: '#66C803' }} />
                <LegendTableCell align="center">= 5</LegendTableCell>
                <LegendTableCell align="left">มาตรฐาน</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{'> 5 ntu'}</LegendTableCell>
                <LegendTableCell align="left">สูงกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{'< 5 ntu'}</LegendTableCell>
                <LegendTableCell align="left">ต่ำกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 10 }}>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center" colSpan={3}>สารละลาย (mg/L)</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="center" width="200px">ค่า</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell style={{ background: '#66C803' }} />
                <LegendTableCell align="center">{'<=1000'}</LegendTableCell>
                <LegendTableCell align="left">มาตรฐาน</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell style={{ background: '#FF0000' }} />
                <LegendTableCell align="center">{'>1000'}</LegendTableCell>
                <LegendTableCell align="left">สูงกว่ามาตรฐาน</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer> */}
      </>
    );
  }

  function MapStormLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.table} size="small" align="center" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell colSpan={5} align="center">
                  Tropical Typhoon Windspeed Scale
                </LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell colSpan={2}> </LegendTableCell>
                <LegendTableCell colSpan={3} align="center">
                  1 Minute Maximum Sustained Winds
                </LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell scope="col" width="200px">Strength</LegendTableCell>
                <LegendTableCell scope="col" align="center">Category</LegendTableCell>
                <LegendTableCell scope="col" align="center">knots</LegendTableCell>
                <LegendTableCell scope="col" align="center">mph</LegendTableCell>
                <LegendTableCell scope="col" align="center">km/h</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <LegendTableCell align="left">Tropical Depression</LegendTableCell>
                <LegendTableCell bgcolor="#00CCFF" align="center">TD</LegendTableCell>
                <LegendTableCell align="center">&lt;34</LegendTableCell>
                <LegendTableCell align="center">&lt;39</LegendTableCell>
                <LegendTableCell align="center">&lt;63</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Tropical Storm</LegendTableCell>
                <LegendTableCell bgcolor="#00FF00" align="center">TS</LegendTableCell>
                <LegendTableCell align="center">34-63</LegendTableCell>
                <LegendTableCell align="center">39-73</LegendTableCell>
                <LegendTableCell align="center">63-118</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Typhoon Cat 1</LegendTableCell>
                <LegendTableCell bgcolor="#FFFF00" align="center"> Cat 1</LegendTableCell>
                <LegendTableCell align="center">64-82</LegendTableCell>
                <LegendTableCell align="center">74-95</LegendTableCell>
                <LegendTableCell align="center">119-153</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Typhoon Cat 2</LegendTableCell>
                <LegendTableCell bgcolor="#FFCC00" align="center">Cat 2</LegendTableCell>
                <LegendTableCell align="center">83-95</LegendTableCell>
                <LegendTableCell align="center">96-110</LegendTableCell>
                <LegendTableCell align="center">154-177</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Typhoon Cat 3</LegendTableCell>
                <LegendTableCell bgcolor="#FF6600" align="center">Cat 3</LegendTableCell>
                <LegendTableCell align="center">96-113</LegendTableCell>
                <LegendTableCell align="center">111-130</LegendTableCell>
                <LegendTableCell align="center">178-210</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Typhoon Cat 4</LegendTableCell>
                <LegendTableCell bgcolor="#FF0000" align="center">Cat 4</LegendTableCell>
                <LegendTableCell align="center">114-135</LegendTableCell>
                <LegendTableCell align="center">131-155</LegendTableCell>
                <LegendTableCell align="center">211-250</LegendTableCell>
              </TableRow>
              <TableRow>
                <LegendTableCell align="left">Super Typhoon Cat 5</LegendTableCell>
                <LegendTableCell bgcolor="#CC00CC" align="center">Cat 5</LegendTableCell>
                <LegendTableCell align="center">&gt;135</LegendTableCell>
                <LegendTableCell align="center">&gt;155</LegendTableCell>
                <LegendTableCell align="center">&gt;250</LegendTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapEarlyWarningLegend() {
    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box p={1} display="flex" justifyContent="center">
              <img src={ImgEWS} alt="Early Warning System" style={{ maxWidth: '100%' }} />
            </Box>
            <Box p={1} display="flex" justifyContent="center">
              {'แหล่งข้อมูล '}
              <Box pl={1}><a href="http://ews.dwr.go.th/" target="_blank" rel="noopener noreferrer" title="ลิงค์ไปยัง">  http://ews.dwr.go.th/</a></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box>ระบบเตือนภัยล่วงหน้าสำหรับพื้นที่เสี่ยงอุทกภัย–ดินถล่ม ตั้งแต่ ปี พ.ศ. 2548 จนถึงปัจจุบัน เพื่อติดตามเฝ้าระวังและเตือนภัยล่วงหน้าพื้นที่เสี่ยงอุทกภัย –ดินถล่มโดยใช้หลักการในการ ตรวจวัดข้อมูลปริมาณน้ำฝนหรือระดับน้ำท่า พร้อมทั้งหาความสัมพันธ์ระหว่างปริมาณน้ำฝนและเหตุการณ์ อุทกภัย–ดินถล่มที่มีแนวโน้มจะเกิดขึ้นและทำให้เกิดความเสียหาย เพื่อกำหนดค่าวิกฤตที่จะใช้ในการเตือนภัย</Box>
            <Box py={2}>โดยข้อมูลอุตุ–อุทกวิทยาที่ตรวจวัดได้ จะถูกส่งผ่านระบบสื่อสารข้อมูล GPRS, IP Star หรือระบบสื่อสารอื่น ที่ทันสมัย เช่น ระบบ 3G มาเก็บไว้ในฐานข้อมูลที่กรมทรัพยากรน้ำที่ส่วนกลาง ณ ห้องปฏิบัติการเฝ้าระวังและ เตือนภัยน้ำหลาก–ดินถล่ม (Early Warning Room) สำนักวิจัย พัฒนาและอุทกวิทยา กรมทรัพยากรน้ำและ ส่วนภูมิภาคที่ส่วนอุทกวิทยา สำนักงานทรัพยากรน้ำภาค 1–11 โดยนำข้อมูลมาวิเคราะห์ประเมินสถานการณ์ ด้วยโปรแกรมประยุกต์ที่ทางกรมทรัพยากรน้ำได้ทำการพัฒนาขึ้น และแจ้งเตือนภัยและรายงานผลผ่านทาง อินเทอร์เน็ต </Box>
            <Box fontWeight={600} pt={2}>สำนักวิจัย พัฒนาและอุทกวิทยา กรมทรัพยากรน้ำ</Box>
            <Box mb={3}>180/3 ถนนพระรามที่ 6 ซอย 34 สามเสนใน พญาไท กรุงเทพฯ 10400 </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  function MapForecastRainfallLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsForecastRainfall.map((row) => (
                <TableRow key={row.color}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapForecastWaveLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsForecastWave.map((row) => (
                <TableRow key={row.color}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  function MapRiskLegend() {
    return (
      <>
        <TableContainer>
          <Table className={classes.tableLegend} aria-label="a dense table">
            <TableHead>
              <TableRow>
                <LegendTableCell align="center">{t('สี')}</LegendTableCell>
                <LegendTableCell align="left" width="300px">{t('ความหมาย')}</LegendTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsRisk.map((row) => (
                <TableRow key={row.color}>
                  <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                  <LegendTableCell align="left">{row.comment}</LegendTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  return (
    <>
      {legend === 'rainfall' && <MapRainfallLegend />}
      {legend === 'dam' && <MapDamLegend />}
      {legend === 'waterlevel' && <MapWaterLevelLegend />}
      {legend === 'waterquality' && <MapQualityLegend />}
      {legend === 'ews' && <MapEarlyWarningLegend />}
      {legend === 'storm' && <MapStormLegend />}
      {legend === 'RainfallForecast' && <MapForecastRainfallLegend />}
      {legend === 'wave' && <MapForecastWaveLegend />}
      {legend === 'risk' && <MapRiskLegend />}
    </>
  );
}

MapLegend.propTypes = {
  legend: PropTypes.string.isRequired,
};
